import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { addListener } from '@analytics/listener-utils';
import { onAnalyticsUnload, track } from '../analytics';
import { WebsiteEvents } from '../constants/events';
var defaultOptions = {
  enabled: true
};
/**
 * This tracker is used to track all anchor tag click events.
 * It dispatch an event when ever user click on anchor tag which have href value
 */

export var userClickTracker = function userClickTracker(options) {
  options = _objectSpread(_objectSpread({}, defaultOptions), options);
  var hasLinks = document.querySelectorAll('a').length > 0;

  if (!options.enabled || !hasLinks) {
    return;
  }

  var removeAnchorTagClickListner = addListener('a', 'click', function (e) {
    var currentTarget = e === null || e === void 0 ? void 0 : e.currentTarget;
    var hrefValue = currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.href;

    if (hrefValue && hrefValue !== '#') {
      var _textValue, _textValue$replace, _textValue$replace$re, _textValue$replace$re2;

      var textValue = currentTarget.text; // Remove the line breaks and arrow from the text

      textValue = (_textValue = textValue) === null || _textValue === void 0 ? void 0 : (_textValue$replace = _textValue.replace(/\n/g, '')) === null || _textValue$replace === void 0 ? void 0 : (_textValue$replace$re = _textValue$replace.replace(/\t/g, '')) === null || _textValue$replace$re === void 0 ? void 0 : (_textValue$replace$re2 = _textValue$replace$re.replace('→', '')) === null || _textValue$replace$re2 === void 0 ? void 0 : _textValue$replace$re2.trim();
      track(WebsiteEvents.USER_CLICK, {
        button_id: currentTarget.id || '',
        button_text: textValue,
        button_place: (currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.dataset['place']) || ''
      });
    }
  });
  onAnalyticsUnload(removeAnchorTagClickListner);
};